
const nameList = [
    {
        entityField: "groupName",
        showField: "按键组名称",
        fieldWeight: 130,
        fieldType: "string",

    },
    {
        entityField: "groupKey",
        showField: "按键组关键字",
        fieldWeight: 100,
        fieldType: "string",

    },
    {
        entityField: "functionKey",
        showField: "功能按键",
        fieldWeight: 100,
        fieldType: "string",

    },
    {
        entityField: "showName",
        showField: "展示标识",
        fieldWeight: 80,
        fieldType: "string",

    },
    {
        entityField: "workKey",
        showField: "实际按键",
        fieldWeight: 130,
        fieldType: "string",

    },
    {
        entityField: "state",
        showField: "状态",
        fieldWeight: 80,
        fieldType: "state",

    },

]







export {nameList}